import { render, staticRenderFns } from "./RegistrationChecklistItemCreate.vue?vue&type=template&id=14beec76&scoped=true"
import script from "./RegistrationChecklistItemCreate.vue?vue&type=script&lang=js"
export * from "./RegistrationChecklistItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14beec76",
  null
  
)

export default component.exports